import { useEffect, useMemo, useState } from 'react';
import Header from '../../components/Header';
import Search from '../../components/Header/Search';
import Banner from '../../components/Banner';
import Outlet from '../../components/Outlet';
import Tags from '../../components/Tags';
import Category from '../../components/Category';
import Group from '../../components/Group';
import Promo from '../../components/Promo';
import Deal from '../../components/Deal';
import { useDispatch, useSelector } from 'react-redux';
import { isEmptyData } from '../../utils/helper';
import { getBannerList } from '../../store/reducers/banner';
import { uniqueID } from '../../utils/constants';
import { getCategoryList } from '../../store/reducers/category';
import SearchLocation from '../../components/SearchLocation';
import { getCardList } from '../../store/reducers/card';
import { WarningGpsPermission } from '../../components/Warning';
import ActiveOrder from '../../components/Order/ActiveOrder';
import useCurrentLocation from '../../hook/useCurrentLocation';

const HEADER_HEIGHT = 56;
const BANNER_HEIGHT = 270;
const SEARCH_HEIGHT = 37;

export default function Home() {
  useCurrentLocation();
	const dispatch = useDispatch();

	const user = useSelector((store) => store?.user || {});
	const { data: banners = [], loading: isLoadingBanner = false } = useSelector((store) => store.banner);
	const { data: cards = [], loading: isLoadingCards = false } = useSelector((store) => store.card);

	const [scrollY, setScrollY] = useState(0);

	useEffect(() => {
		if (isEmptyData(user?.token)) return;
		dispatch(
			getBannerList({
				latitude: user?.latitude,
				longitude: user?.longitude,
			}),
		);
	}, [dispatch, user?.token]);

	useEffect(() => {
    if (isEmptyData(user?.token)) return;
		dispatch(getCategoryList());
	}, [dispatch, user?.token]);

	useEffect(() => {
		if (isEmptyData(user?.latitude) || isEmptyData(user?.longitude) || isEmptyData(user?.token)) return;
		dispatch(
			getCardList({
				latitude: user?.latitude,
				longitude: user?.longitude,
			}),
		);
	}, [dispatch, user?.latitude, user?.longitude, user?.token]);

	useEffect(() => {
		const onScroll = () => {
			setScrollY(window.scrollY);
		};

		window.addEventListener('scroll', onScroll, {
			passive: true,
		});

		return () => {
			window.removeEventListener('scroll', onScroll);
		};
	}, []);

	// posisi awal search
	const searchStart = BANNER_HEIGHT - SEARCH_HEIGHT / 1.25;
	// posisi akhir (sticky)
	const stickyTop = HEADER_HEIGHT + 8;
	// posisi search sekarang
	const searchY = Math.max(stickyTop, searchStart - scrollY);
	// jarak search ke posisi sticky
	const distance = searchY - stickyTop;
	// mulai fade ketika tinggal 50px lagi
	const START_FADE = 50;

	const progress = Math.max(0, Math.min(1, 1 - distance / START_FADE));

	const headerProps = {
		progress,
	};

	const searchProps = {
		searchY,
		progress,
	};

	const firstBannerProps = useMemo(() => {
		return {
			progress,
			banners: banners?.filter((b) => Number(b?.position) === 1),
			isLoading: isLoadingBanner,
      isHidden: false,
		};
	}, [isLoadingBanner, banners]);

	const secondBannerProps = {
		progress,
		banners: banners?.filter((b) => Number(b?.position) === 3),
		isLoading: isLoadingBanner,
		containerClassName: 'w-full relative mb-8 h-[210px] p-4',
		imageClassName: 'w-full h-[210px] object-fill rounded-lg',
		isShowProgress: false,
		disabled: true,
	};

	const promoProps = {
		progress,
		banner: banners?.find((b) => Number(b?.position) === 2),
		isLoading: isLoadingBanner,
	};

	const superDealProps = {
		data: cards?.find((b) => Number(b?.sequence) === 1),
		isLoading: isLoadingCards,
	};

	const favoriteProps = {
		data: cards?.find((b) => Number(b?.sequence) === 2),
		isLoading: isLoadingCards,
	};

	return (
		<div className='mx-auto min-h-screen max-w-md'>
			<Header {...headerProps} />
			<Search {...searchProps} />
			<Banner {...firstBannerProps} />
			<Category />
			<Group />
			<Promo {...promoProps} />
			<Deal {...superDealProps} />
      <Banner {...secondBannerProps} />
			<Deal {...favoriteProps} />
			<Tags />
			<Outlet />
			<SearchLocation />
      <WarningGpsPermission />
      <ActiveOrder />
		</div>
	);
}
